import React from "react";
import demoImg1 from "../../Assets/Images/contactImg.jpg";

const ContactSection = () => {
  return (
    <div className="px-4 md:px-10 bg-white pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-center">
        {/* Left Side - Image */}
        <div className="col-span-2 flex justify-center items-center">
          <img
            src={demoImg1}
            alt="Demo"
            className="relative z-10 w-full rounded-lg"
          />
        </div>

        {/* Right Side - Form */}
        <div className="space-y-4 col-span-3">
          <p className="text-[#E8471B] font-montserrat font-medium text-[20px] leading-[24px] tracking-[0.5px] align-middle capitalize">
            Get In Touch
          </p>
          <h2 className="font-orbitron font-semibold text-[45px] leading-[130%] tracking-[1px] align-middle capitalize text-[#030B25]">
            Connect With Us
          </h2>

          <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="Enter Your Name"
              required
              className="border rounded-md px-4 py-3 w-full focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
            <input
              type="text"
              placeholder="Enter Phone Number"
              required
              className="border rounded-md px-4 py-3 w-full focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
            <input
              type="email"
              placeholder="Enter Email"
              required
              className="border rounded-md px-4 py-3 w-full focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
            <input
              type="text"
              placeholder="Enter Your Subject"
              required
              className="border rounded-md px-4 py-3 w-full focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
            <textarea
              placeholder="Enter Messaage"
              className="border rounded-md px-4 py-3 md:col-span-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-400"
              rows={5}
            ></textarea>
            <button
              type="submit"
              className="bg-[#E8471B] text-white font-medium px-6 py-3 rounded-md hover:bg-orange-600 transition"
            >
              Send A Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
